import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/courses/:courseId/activities/:activityId/survey/:id/:attemptId?',
        component: () => import('@/pages/courses/quizzes/Quiz.vue'),
        props: true,
        children: [
            {
                name: 'survey-attempt',
                path: '',
                component: () => import('@/components/quiz-attempt/QuizAttempt.vue'),
                meta: {
                    title: 'Survey',
                    middleWare: [GateKeeperMiddleware],
                    ability: { action: 'take', subject: 'quiz' },
                },
            },
        ],
    },
];
